module.exports = __webpack_public_path__ + "static/media/eho-black.7fddaef5.png";